export default "__VITE_ASSET__AC3oYtRd__"